function PilatesIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.5 12C29.6046 12 30.5 11.1046 30.5 10C30.5 8.89543 29.6046 8 28.5 8C27.3954 8 26.5 8.89543 26.5 10C26.5 11.1046 27.3954 12 28.5 12ZM28.5 14C30.7091 14 32.5 12.2091 32.5 10C32.5 7.79086 30.7091 6 28.5 6C26.2909 6 24.5 7.79086 24.5 10C24.5 12.2091 26.2909 14 28.5 14Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.3374 18.251C13.7465 17.8891 14.3702 17.9224 14.7385 18.3257L25.2385 29.8257C25.6109 30.2336 25.5821 30.8661 25.1743 31.2385C24.7664 31.6109 24.1339 31.5821 23.7615 31.1743L13.9253 20.4012L1.66259 31.249C1.24893 31.6149 0.616944 31.5762 0.251015 31.1626C-0.114914 30.7489 -0.0762217 30.1169 0.337438 29.751L13.3374 18.251Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.4877 9.50008C20.7919 9.49632 21.0813 9.63128 21.274 9.86676L25.774 15.3668C25.9559 15.5891 26.0334 15.879 25.9868 16.1625C25.9401 16.446 25.7737 16.6957 25.53 16.848L17.53 21.848C17.0617 22.1407 16.4448 21.9983 16.152 21.53C15.8593 21.0617 16.0017 20.4447 16.47 20.152L23.5068 15.7541L20.5198 12.1034L14.2894 20.1139C13.9503 20.5499 13.3221 20.6284 12.8861 20.2894C12.4502 19.9503 12.3716 19.322 12.7107 18.8861L19.7107 9.88606C19.8975 9.64589 20.1835 9.50383 20.4877 9.50008Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23.2545 0.0329266C23.7886 0.173479 24.1076 0.720394 23.9671 1.25449L21.5968 10.2614L25.774 15.3668C25.8473 15.4564 25.9045 15.558 25.943 15.6672L28.943 24.1672C29.1268 24.688 28.8536 25.2592 28.3328 25.443C27.812 25.6268 27.2408 25.3536 27.057 24.8328L24.1153 16.4978L19.7261 11.1332C19.5232 10.8853 19.4514 10.5553 19.5329 10.2455L22.0329 0.745508C22.1735 0.211407 22.7204 -0.107626 23.2545 0.0329266Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default PilatesIcon;
